import { useMemo } from "react";

const useGetFormValueAsNumber = (watchValue: string | null | undefined) => {
    return useMemo(() => {
        let value = 0;

        if (typeof watchValue === "string") {
            // Remove all non-numeric characters except decimal point and minus sign
            // This handles $, commas, spaces, and other currency symbols
            const sanitizedValue = watchValue.trim().replace(/[^0-9.-]/g, ""); // Keep only digits, decimal, and minus

            // Handle edge cases like multiple decimals or minus signs
            const parts = sanitizedValue.split(".");
            let cleanValue = parts[0];
            if (parts.length > 1) {
                // Keep only the first decimal point
                cleanValue = `${parts[0]}.${parts.slice(1).join("")}`;
            }

            // Ensure minus sign is only at the beginning
            const isNegative = cleanValue.includes("-");
            cleanValue = cleanValue.replace(/-/g, "");
            if (isNegative && cleanValue !== "") {
                cleanValue = `-${cleanValue}`;
            }

            value = Number.parseFloat(cleanValue);

            if (Number.isNaN(value) || value === Number.POSITIVE_INFINITY) {
                value = 0;
            }
        }

        return value;
    }, [watchValue]);
};

export default useGetFormValueAsNumber;
